import { computed, ref } from "@vue/composition-api";
import { LivechatSubjectType, LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import useOnUserLogin from "@/hooks/useOnUserLogin";
import { ROLES } from "@/const";
import { useSubscribeAccessibilityUpdated } from "./useSubscribeAccessibilityUpdated";
import useLiveChat from "../../hooks/useLiveChat";

export default function useSingleLiveChat({
  userId,
  connectionDelay = 0,
}: {
  userId: string;
  connectionDelay?: number;
}) {
  const subject = ref({
    subjectId: userId,
    subjectType: LivechatSubjectType.PUBLIC_LIVECHAT,
  });

  const {
    loading,
    joinData,
    clientServerTimeDiff,
    isBlockedForSession,
    errorData,
    setOnUserBroadcastingCB,
    joinChat,
    endChat,
  } = useLiveChat({ subject });

  useOnUserLogin(async () => {
    await joinChat();
  });

  const userList = computed<LiveChatUser[]>(() =>
    (joinData.value?.users ?? []).filter(i => i.userId !== userId && i.user?.role !== ROLES.ADMIN)
  );

  useSubscribeAccessibilityUpdated(subject.value, async () => {
    await endChat();
    await joinChat();
  });

  joinChat(connectionDelay);

  return {
    loading,
    joinData,
    userList,
    clientServerTimeDiff,
    errorData,
    isBlockedForSession,
    setOnUserBroadcastingCB,
    endChat,
  };
}
